import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { getCheckoutStatus } from "../api";
import { format, parseISO } from "date-fns";
import { nl } from "date-fns/locale";

const MAX_ATTEMPTS = 6;

const PaymentReturn = () => {
  const { status } = useParams();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const isSuccessRoute = status === "succes";

  const [state, setState] = useState(isSuccessRoute && sessionId ? "checking" : (isSuccessRoute ? "success" : "cancel"));
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!(isSuccessRoute && sessionId)) return;
    let attempts = 0;
    let active = true;
    const poll = async () => {
      try {
        const data = await getCheckoutStatus(sessionId);
        if (!active) return;
        if (data.payment_status === "paid") { setInfo(data); setState("success"); return; }
        if (data.status === "expired") { setState("cancel"); return; }
        attempts += 1;
        if (attempts >= MAX_ATTEMPTS) { setState("pending"); return; }
        setTimeout(poll, 2000);
      } catch (e) {
        if (!active) return;
        attempts += 1;
        if (attempts >= MAX_ATTEMPTS) { setState("pending"); return; }
        setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { active = false; };
  }, [isSuccessRoute, sessionId]);

  if (state === "checking") {
    return (
      <div className="max-w-xl mx-auto px-4 py-24 text-center">
        <Loader2 className="w-12 h-12 text-brand-blue animate-spin mx-auto" />
        <h1 className="font-display font-bold text-2xl text-brand-navy mt-6">Betaling controleren...</h1>
        <p className="text-slate-500 mt-3">Een moment geduld terwijl we je betaling bevestigen.</p>
      </div>
    );
  }

  const success = state === "success";
  const pending = state === "pending";

  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center">
      <div className={`w-20 h-20 rounded-full mx-auto flex items-center justify-center ${success ? "bg-brand-greenlight" : pending ? "bg-brand-bluelight" : "bg-brand-pinklight"}`}>
        {success ? <CheckCircle2 className="w-10 h-10 text-brand-green" /> : pending ? <Loader2 className="w-10 h-10 text-brand-blue" /> : <XCircle className="w-10 h-10 text-brand-pink" />}
      </div>
      <h1 className="font-display font-bold text-3xl text-brand-navy mt-6">
        {success ? "Bedankt voor je reservering!" : pending ? "Betaling wordt verwerkt" : "Betaling geannuleerd"}
      </h1>
      <p className="text-slate-500 mt-4">
        {success
          ? `Je reservering${info?.order_no ? ` (${info.order_no})` : ""} is bevestigd${info?.items_count ? ` voor ${info.items_count} springkussen${info.items_count > 1 ? "s" : ""}` : ""}. Je ontvangt binnenkort een bevestiging per e-mail.`
          : pending
          ? "Je betaling wordt nog verwerkt. Je ontvangt een bevestiging per e-mail zodra deze rond is."
          : "Er is niets afgeschreven. Je kan het opnieuw proberen of contact met ons opnemen."}
      </p>
      <Link to="/onze-luchtkastelen" className="inline-flex mt-8 rounded-full bg-brand-blue hover:bg-brand-bluedark text-white font-bold px-7 py-3.5 transition-colors">
        Terug naar het aanbod
      </Link>
    </div>
  );
};

export default PaymentReturn;
